import React, { useState, useEffect } from "react";
import { Radio, Space, Checkbox } from "antd";
import { useSelector } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import "../ExperienceLevelFilter/ExperienceFilter.css";
import "./location.filter.css";
import { useParams } from "react-router-dom";

const FilterVisa = (props) => {
  const CheckBoxGroup = Checkbox.Group;
  const { id, name } = useParams();
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const Count = useSelector(
    (state) => state.searchSkillListingReducer.skillListingCount
  );
  const countLoading = useSelector(
    (state) => state.searchSkillListingReducer.countLoading
  );
  const totalCountError = useSelector(
    (state) => state.searchSkillListingReducer.error
  );

  const onExperienceCheckboxClicked = (checkedValues) => {
    const selectedCheckboxesIds = checkedValues.map((value) => {
      const checkbox = ExperienceName.find(
        (checkbox) => checkbox.value === value
      );
      return checkbox.id;
    });

    const selectedCheckboxesValueId = checkedValues.map((value) => {
      const checkbox = ExperienceName.find(
        (checkbox) => checkbox.value === value
      );
      return { id: checkbox.id, name: checkbox.value };
    });
    props.setCheckedBox(selectedCheckboxesValueId);
    props.setRadioCheck(selectedCheckboxesIds);
  };

  const getCheckedValues = (value2) => {
    const commonValues = ExperienceName?.filter((experience) =>
      value2.some((selectedExp) => selectedExp?.id === experience?.id)
    );
    return commonValues?.map((item) => item.value);
  };

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const ExperienceName = [
    {id: 5, value:'US Resident/Citizen'},
    {id: 9, value:'EAD'},
    {id: 8, value:'H1-B'}
  ];

  const generateCheckBoxOptions = () => {
    const options = ExperienceName.map((name,index,array) => {
      const matchingCount = Count?.result?.visaStatusCount?.find(
        (count) => count?.title == name?.value
      );
  
      const count = matchingCount ? matchingCount.count : 0;
  
      // label: `${name.value} (${count})`,
      return {
        label: (
          <div style={{ display: "flex", justifyContent: "space-between",marginBottom:array.length-1==index?'8px':'18px',paddingRight:'0px' }}>
            <span>{name.value}</span>
            {/* {props?.fromCandMkt || id ? null :  <> <span>({count})</span> </>} */}
          </div>
        ),
        value: name.value,
        id: name.id,
      };
    });
  
    return options;
  };

  // options={ExperienceName.map((name, index) => ({
  //   label: `${name.value} ${}`,
  //   value: name.value,
  //   id: name.id,
  // }))}
  return (
    <div>
      <CheckBoxGroup
        style={{ display: "flex", flexDirection: "column", columnGap: '1px', width: '100.5%' }}
        options={generateCheckBoxOptions()}
        value={getCheckedValues(props.checkBox)}
        onChange={onExperienceCheckboxClicked}
      />
    </div>
  );
};

export default FilterVisa;
